import { render } from "./workplace.vue?vue&type=template&id=d748d58c&scoped=true"
import script from "./workplace.vue?vue&type=script&lang=js"
export * from "./workplace.vue?vue&type=script&lang=js"

import "./workplace.vue?vue&type=style&index=0&id=d748d58c&scoped=true&lang=css"
import "./workplace.vue?vue&type=style&index=1&id=d748d58c&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d748d58c"]])

export default __exports__